import { ACTIVE_FILTER, FILTER_DATA, MENU_DATA, MENU_FIXED, SEARCH, SECTION_DATA } from "../types/menu";
import { collection, getDocs, query, orderBy, doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import { HOSTNAME } from "../../config/constants";
import { setactiveOutlet, setrestaurantConfig } from "./config";
import { formatDate } from "../../functions/conversion";

export const getConfig = () => async (dispatch) => {
  // Get Config

  try {
    const configRef = doc(db, "config", HOSTNAME);

    const docSnapshot = await getDoc(configRef);

    if (docSnapshot.exists()) {
      const restaurantConfig = docSnapshot.data();
      dispatch(setrestaurantConfig(restaurantConfig));
      const root = document.querySelector(":root");
      root.style.setProperty("--color-primary", restaurantConfig.theme.primary);
      root.style.setProperty("--color-secondary", restaurantConfig.theme.secondary);
      root.style.setProperty("--color-tertiary", restaurantConfig.theme.tertiary);
    }
  } catch (error) {
    console.log(error);
  }
};

export const getData = (outlet) => async (dispatch, getState) => {
  // Get Data

  if (outlet) {
    dispatch({ type: SECTION_DATA, payload: null });
  }

  let filter = [],
    section = [],
    menu = {};

  if (outlet) {
    const menuDataRef = doc(db, "menuData", HOSTNAME);
    const outletRef = doc(menuDataRef, "outlet", outlet);

    const filterRef = collection(outletRef, "filter");
    const sectionRef = collection(outletRef, "section");
    const menuRef = collection(outletRef, "menu");
    const filterSnapshot = await getDocs(query(filterRef, orderBy("order")));
    const sectionSnapshot = await getDocs(query(sectionRef, orderBy("order")));
    const menuSnapshot = await getDocs(query(menuRef));

    filterSnapshot.forEach((doc) => {
      filter.push(doc.data());
    });
    sectionSnapshot.forEach((doc) => {
      section.push(doc.data());
    });
    menuSnapshot.forEach((doc) => {
      const data = doc.data();
      menu = { ...menu, [data.id]: data };
    });
  }

  dispatch({ type: FILTER_DATA, payload: filter });
  dispatch({ type: MENU_DATA, payload: menu });

  if (outlet) {
    const { activeOutlet } = getState().config;

    if (!activeOutlet || outlet !== activeOutlet.outletId) {
      const configRef = doc(db, "config", HOSTNAME);
      const docSnapshot = await getDoc(configRef);
      if (docSnapshot.exists()) {
        const restaurantConfig = docSnapshot.data();
        let activeOutletData = null;

        restaurantConfig.outlets.forEach((item) => {
          if (item.outletId === outlet) {
            activeOutletData = item;
          }
        });
        dispatch(setactiveOutlet(activeOutletData));
      }
    }

    // setTimeout(() => {
    dispatch({ type: SECTION_DATA, payload: section });
    // }, 1000);
  } else {
    setTimeout(() => {
      dispatch({ type: SECTION_DATA, payload: section });
    }, 1000);
  }
};

export const setsearch = (search) => async (dispatch) => {
  dispatch({
    type: SEARCH,
    payload: search,
  });
};

export const setfilter = (item, index) => async (dispatch, getState) => {
  // const filter = getState().menu.filterData;
  // const filterDataCopy = JSON.parse(JSON.stringify(filter));
  // filterDataCopy[index].isSelected = !item.isSelected;

  // dispatch({
  //   type: FILTER_DATA,
  //   payload: filterDataCopy,
  // });

  const activeFilter = getState().menu.activeFilter;

  if (activeFilter.includes(item.ref)) {
    const removeFilter = activeFilter.filter((itemFilter) => itemFilter !== item.ref);
    dispatch({ type: ACTIVE_FILTER, payload: removeFilter });
  } else {
    dispatch({ type: ACTIVE_FILTER, payload: [...activeFilter, item.ref] });
  }
};

export const setmenuData = (menu) => (dispatch) => {
  dispatch({ type: MENU_DATA, payload: menu });
};

export const setmenuFixed = (menu) => (dispatch) => {
  dispatch({ type: MENU_FIXED, payload: menu });
};

export const setfilterData = (filter) => (dispatch) => {
  dispatch({ type: FILTER_DATA, payload: filter });
};

export const setsectionData = (section) => (dispatch) => {
  dispatch({ type: SECTION_DATA, payload: section });
};

export const resetFilter = () => (dispatch) => {
  dispatch({ type: ACTIVE_FILTER, payload: [] });
};
